export default __webpack_public_path__ + "static/media/quickbooks.de62c70d.jpg";